// Components
import TelegramIcon from './icons/TelegramIcon';
import XIcon from './icons/XIcon';
import DiscordIcon from './icons/DiscordIcon';
import ArrowIcon from './icons/ArrowIcon';
import Link from '../ui/Link/Link';

// Config
import { TELEGRAM_LINK } from '../../config';

// Styles
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={styles.wrapper}>
      <div className={styles.socials}>
        <p className={styles.socialsTitle}>Social media</p>
        <div className={styles.socialsList}>
          <Link to="https://x.com/TMXTribe/" target="_blank">
            <XIcon />
          </Link>
        </div>
      </div>
      <div className={styles.copyrightWrapper}>
        <img src="./images/footer_logo.png" alt="Footeer logo" />
        <p className={styles.copyrightText}>Copyright © 2025 TMX All Rights Reserved.</p>
      </div>
      <div className={styles.contacts}>
        <p className={styles.socialsTitle}>Contact us</p>
        <div className={styles.socialsList}>
          <Link to={TELEGRAM_LINK} target="_blank">
            <TelegramIcon />
          </Link>
          <Link to="https://x.com/TMXTribe/" target="_blank" className={styles.xIcon}>
            <XIcon />
          </Link>
          <Link to="https://discord.com/" target="_blank">
            <DiscordIcon />
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
